import styles from './main.module.scss'

const Main = () => {
  return <div className={styles.main}>메인</div>
}

export default Main
